import React, { useEffect } from "react";
import { labelUtils } from "../Util";
import FormGroupWrapper from "./FormGroupWrapper";
import { useDispatch, useSelector } from "react-redux";
import { setRendererFormState } from "../../../../slices/common/reducer";

const Numeric = ({
  arrEle,
  newElfromJSON,
  fieldEle,
  formState,
  displayLabelKey,
  databaseKey,
  showRequired = true,
}) => {
  const dispatch = useDispatch();
  const key = databaseKey ? databaseKey : displayLabelKey;
  const numericError = useSelector(
    (state) => state.common.formRendererValidation.numeric
  );
  // const isRequired = showRequired ? fieldEle?.["display-required"] === 1 : false;

  const handleChange = (e) => {
    const value = e.target.value;
    dispatch(setRendererFormState({ key, value }));
  };

  const validationClass = numericError ? "is-invalid" : "";

  return (
    <FormGroupWrapper
      arrEle={arrEle}
      newElfromJSON={newElfromJSON}
      fieldEle={fieldEle}
    >
      <div
        className={`form-group ${validationClass}`}
        style={{ width: labelUtils.getElementWidth(fieldEle) }}
      >
        <style>{`
          /* Hide the spinner controls */
          input[type="number"]::-webkit-inner-spin-button,
          input[type="number"]::-webkit-outer-spin-button {
            -webkit-appearance: none;
            margin: 0;
          }
          input[type="number"] {
            -moz-appearance: textfield; /* Firefox */
          }
        `}</style>
        <input
          id={newElfromJSON}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
            }
          }}
          className={`form-control mandatory ${validationClass}`}
          type="number"
          placeholder={fieldEle?.["display-placeholder"]}
          disabled={fieldEle?.["display-disabled"] === 1}
          required={showRequired ? fieldEle?.["display-required"] === 1 : false}
          min={fieldEle?.["validation-minvalue"]}
          max={fieldEle?.["validation-maxvalue"]}
          name={key}
          value={formState[key] || ""}
          onChange={handleChange}
        />
        {numericError && (
          <div className="invalid-feedback">This field is required</div>
        )}{" "}
        {fieldEle?.["display-description"] && (
          <div className="form-text text-muted formElementDesc">
            {fieldEle?.["display-description"]}
          </div>
        )}
      </div>
    </FormGroupWrapper>
  );
};

export default Numeric;
